var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtencinalpacienteHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.758,
    height: 41.188,
    viewBox: "0 0 44.758 41.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_149080",
    "data-name": "Rect\\xE1ngulo 149080",
    width: 44.758,
    height: 41.188,
    fill: "#05294f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atenci\\xF3n_al_paciente_Home",
    "data-name": "Atenci\\xF3n al paciente Home",
    transform: "translate(-600.254 -1555.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164211",
    "data-name": "Grupo 164211",
    transform: "translate(600.254 1555.824)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86066",
    "data-name": "Trazado 86066",
    d: "M294.945,23.415c0-.451,0-.9,0-1.352a22.844,22.844,0,0,0-1.332-8.477q-2.192-5.709-4.638-11.321A3.658,3.658,0,0,0,283.382.728a3.722,3.722,0,0,0-1.165,4.633c.791,1.872,1.6,3.737,2.4,5.606.565,1.321,1.12,2.647,1.693,3.965a.88.88,0,0,0,1.405.458c.342-.276.407-.648.18-1.185-.634-1.5-1.275-2.991-1.914-4.486-.724-1.7-1.454-3.388-2.168-5.088a1.959,1.959,0,0,1,1.016-2.722,2,2,0,0,1,2.665,1.259c1.246,2.988,2.472,5.983,3.729,8.966a22.71,22.71,0,0,1,1.9,7.918c.078,1.9.053,3.807.075,5.71,0,.305-.011.612.014.915a.825.825,0,0,0,.578.748.721.721,0,0,0,.872-.21,1.491,1.491,0,0,0,.273-.793c.031-1,.012-2.006.012-3.009",
    transform: "translate(-251.066 0)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86067",
    "data-name": "Trazado 86067",
    d: "M100.895,338a.869.869,0,1,0-.87-.85.878.878,0,0,0,.87.85",
    transform: "translate(-89.095 -299.522)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86068",
    "data-name": "Trazado 86068",
    d: "M294.561,338.019a.882.882,0,0,0,.836-.883.869.869,0,0,0-1.738.009.909.909,0,0,0,.9.874",
    transform: "translate(-261.571 -299.536)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86069",
    "data-name": "Trazado 86069",
    d: "M386.467,270.4a.873.873,0,0,0,.885-.838.867.867,0,0,0-1.734-.032.866.866,0,0,0,.849.871",
    transform: "translate(-343.48 -239.321)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86070",
    "data-name": "Trazado 86070",
    d: "M0,33.826l.753-.756.126.076v-.515c0-3.33.042-6.661-.011-9.991A27.61,27.61,0,0,1,3.2,10.985c1.222-2.794,2.35-5.628,3.522-8.443A3.776,3.776,0,0,1,9.554.138a3.685,3.685,0,0,1,4.257,4.624c-.428,1.307-1.027,2.558-1.565,3.828q-1.341,3.169-2.7,6.33c-.252.588-.617.81-1.1.686a.814.814,0,0,1-.616-1.033,10.648,10.648,0,0,1,.43-1.093Q10.131,9.091,12,4.7A1.981,1.981,0,1,0,8.4,3.086C7.868,4.3,7.371,5.522,6.87,6.744c-1,2.432-2.036,4.848-2.962,7.306A21.358,21.358,0,0,0,2.63,21.575c-.011,3.723,0,7.446,0,11.169,0,.127.014.254.022.4H14.274c.019-.028.035-.041.034-.053-.034-2.392.256-4.8-.233-7.17a7.59,7.59,0,0,0-1.387-3.076q-1.542-2.034-3.156-4.014a1.51,1.51,0,0,0-2.634.308,1.587,1.587,0,0,0,.224,1.568c.851,1.268,1.693,2.541,2.539,3.812.145.218.3.431.431.656a.884.884,0,0,1-.211,1.238.858.858,0,0,1-1.248-.3c-1.055-1.568-2.124-3.129-3.128-4.729a3.252,3.252,0,0,1,5.24-3.814c1.284,1.56,2.557,3.138,3.7,4.8a9.906,9.906,0,0,1,1.636,5.743q0,2.269,0,4.537v.463c.753.294.874.473.874,1.277q0,2.836,0,5.672a2.15,2.15,0,0,1-.048.518.849.849,0,0,1-1.652-.009,2.223,2.223,0,0,1-.045-.518q0-2.312,0-4.625v-.493H1.748v.471c0,1.6.006,3.2,0,4.8,0,.786-.659,1.267-1.259.912C.282,41,.16,40.742,0,40.545V33.826",
    transform: "translate(0 -0.054)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86071",
    "data-name": "Trazado 86071",
    d: "M271.315,174.111c-.16.2-.282.457-.487.578-.6.355-1.255-.126-1.259-.911-.008-1.585,0-3.17,0-4.755v-.506H256.1v1c0,1.41,0,2.821,0,4.231a.918.918,0,0,1-.69,1.025.865.865,0,0,1-1.05-.874c-.023-.537-.007-1.076-.007-1.614q0-2.181,0-4.362c0-.763.139-.963.874-1.235,0-1.628-.043-3.271.016-4.91a16.436,16.436,0,0,1,.37-2.973,9.17,9.17,0,0,1,1.743-3.626c1.051-1.356,2.1-2.716,3.2-4.031a3.051,3.051,0,0,1,3.273-1.019,3.1,3.1,0,0,1,2.355,2.388,2.913,2.913,0,0,1-.326,2.356c-1.043,1.628-2.119,3.234-3.2,4.838a.846.846,0,0,1-1.219.278.885.885,0,0,1-.182-1.306q1.449-2.205,2.921-4.4a1.657,1.657,0,0,0,.285-1.444,1.517,1.517,0,0,0-2.4-.737,2.022,2.022,0,0,0-.305.31c-1,1.265-2.022,2.518-3,3.8a8.662,8.662,0,0,0-1.777,5.233c-.024,1.657-.007,3.315-.006,4.973,0,.085.011.169.021.308h.57q6.271,0,12.541,0a1.141,1.141,0,0,1,1.2.66Z",
    transform: "translate(-226.557 -133.619)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86072",
    "data-name": "Trazado 86072",
    d: "M121.148,78.72a6.028,6.028,0,0,1,4.458-5.846,5.114,5.114,0,0,1,4.341.892.46.46,0,0,0,.645.03,5.4,5.4,0,0,1,8.175,2.219,5.8,5.8,0,0,1-.576,6.139,26.334,26.334,0,0,1-5.6,5.647c-.557.444-1.141.855-1.714,1.278a.908.908,0,0,1-1.169,0,32.734,32.734,0,0,1-6.649-6.009,8.345,8.345,0,0,1-1.719-3.2c-.092-.378-.129-.77-.191-1.156m1.785.235a4.789,4.789,0,0,0,1.1,2.5,27.09,27.09,0,0,0,6.059,5.74.44.44,0,0,0,.4-.008c.409-.278.8-.581,1.186-.891a25.934,25.934,0,0,0,4.9-4.88,4.285,4.285,0,0,0,.48-4.889,3.665,3.665,0,0,0-5.737-1.1c-.945.88-1.135.879-2.09-.009-.032-.03-.062-.062-.1-.089a3.473,3.473,0,0,0-2.841-.824,4.28,4.28,0,0,0-3.369,4.444",
    transform: "translate(-107.91 -64.772)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86073",
    "data-name": "Trazado 86073",
    d: "M294.946,23.415c0,1,.019,2.007-.012,3.009a1.49,1.49,0,0,1-.273.793.721.721,0,0,1-.872.21.825.825,0,0,1-.578-.748c-.025-.3-.01-.61-.014-.915-.021-1.9,0-3.809-.075-5.71a22.709,22.709,0,0,0-1.9-7.918c-1.257-2.983-2.483-5.979-3.729-8.966a2,2,0,0,0-2.665-1.259,1.958,1.958,0,0,0-1.016,2.722c.714,1.7,1.444,3.392,2.168,5.088.638,1.5,1.28,2.989,1.914,4.486.227.537.162.909-.18,1.185a.88.88,0,0,1-1.4-.458c-.573-1.318-1.128-2.643-1.693-3.965-.8-1.869-1.606-3.734-2.4-5.606A3.722,3.722,0,0,1,283.383.728a3.658,3.658,0,0,1,5.594,1.537q2.438,5.609,4.638,11.321a22.844,22.844,0,0,1,1.332,8.477c0,.451,0,.9,0,1.352",
    transform: "translate(-251.067 0)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86074",
    "data-name": "Trazado 86074",
    d: "M100.895,338a.878.878,0,0,1-.87-.85.87.87,0,1,1,.87.85",
    transform: "translate(-89.095 -299.522)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86075",
    "data-name": "Trazado 86075",
    d: "M294.561,338.019a.909.909,0,0,1-.9-.874.869.869,0,0,1,1.738-.009.882.882,0,0,1-.836.883",
    transform: "translate(-261.571 -299.536)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86076",
    "data-name": "Trazado 86076",
    d: "M386.467,270.4a.866.866,0,0,1-.849-.871.867.867,0,0,1,1.734.032.873.873,0,0,1-.885.838",
    transform: "translate(-343.48 -239.321)",
    fill: "#05294f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtencinalpacienteHome);
export default __webpack_public_path__ + "static/media/Atención al paciente Home.b2447e698919824a2977024cb08ff3bd.svg";
export { ForwardRef as ReactComponent };